'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { UserAvatar } from '@/components/images/user-avatar';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Skeleton } from '@/components/ui/app-skeleton';
import { Icon } from '@/components/ui/icon';
import { UserGroup03IconSolid } from '@/components/ui/icon/glyphs';
import { SilkSheet } from '@/components/ui/silk-sheet';
import type { MarketBoosterLeaderboardEntry } from './types';
export interface MarketBoostersSummaryViewProps {
  count: number | null;
  boosters: readonly MarketBoosterLeaderboardEntry[];
  pending?: boolean;
  failed?: boolean;
  boostable?: boolean;
  onOpen?: () => void;
  children: React.ReactNode;
}
export function MarketBoostersSummaryView(t0) {
  const $ = _c(34);
  const {
    count,
    boosters,
    pending: t1,
    failed: t2,
    boostable: t3,
    onOpen,
    children
  } = t0;
  const pending = t1 === undefined ? false : t1;
  const failed = t2 === undefined ? false : t2;
  const boostable = t3 === undefined ? true : t3;
  const t = useTranslations("market.boosters");
  const [open, setOpen] = useState(false);
  let t4;
  if ($[0] !== boostable || $[1] !== count || $[2] !== t) {
    t4 = count === null ? t("view_boosters") : count === 0 && !boostable ? t("no_boosters_closed") : t("people_boosted", {
      count
    });
    $[0] = boostable;
    $[1] = count;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const label = t4;
  const loading = pending && boosters.length === 0 && count !== 0;
  let t5;
  if ($[4] !== onOpen) {
    t5 = () => {
      onOpen?.();
      setOpen(true);
    };
    $[4] = onOpen;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== boosters || $[7] !== count || $[8] !== loading) {
    t6 = loading ? <Skeleton className="h-6 w-14 rounded-full" /> : boosters.length > 0 && count !== 0 ? <span className="flex items-center" aria-hidden="true">{boosters.slice(0, 3).map(_temp)}</span> : <Icon icon={UserGroup03IconSolid} className="size-6" aria-hidden="true" />;
    $[6] = boosters;
    $[7] = count;
    $[8] = loading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== count || $[11] !== label || $[12] !== loading) {
    t7 = loading && count === null ? <Skeleton className="h-3 w-24" /> : <span>{label}</span>;
    $[10] = count;
    $[11] = label;
    $[12] = loading;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== failed || $[15] !== t) {
    t8 = failed ? <span className="text-foreground-tertiary">{t("summary_unavailable")}</span> : null;
    $[14] = failed;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== label || $[18] !== loading || $[19] !== open || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <AnimatedButton variant="tertiary" className="ml-auto h-auto min-h-11 flex-col items-end gap-1 rounded-control px-1 py-0 text-caption text-foreground-secondary hover:bg-transparent hover:shadow-none" onClick={t5} aria-label={label} aria-haspopup="dialog" aria-expanded={open} aria-busy={loading} data-testid="market-boosters-summary">{t6}{t7}{t8}</AnimatedButton>;
    $[17] = label;
    $[18] = loading;
    $[19] = open;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("tab_label");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = open ? children : null;
  let t12;
  if ($[27] !== open || $[28] !== t10 || $[29] !== t11) {
    t12 = <SilkSheet open={open} onOpenChange={setOpen} title={t10} size="xl">{t11}</SilkSheet>;
    $[27] = open;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t9) {
    t13 = <>{t9}{t12}</>;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}
function _temp(t0) {
  const {
    participationId,
    booster
  } = t0;
  return <span key={participationId} className="-ml-3 first:ml-0"><UserAvatar className="size-6" size="sm" userId={booster.userId ?? booster.walletAddress} displayName={booster.displayName} avatarUrl={booster.avatarUrl} initialsMaxChars={1} nsfw={booster.avatarNsfw ?? false} rasterise={booster.avatarPreferences?.rasterise ?? false} borderWidth={1} borderColor="border-background-primary" /></span>;
}